import { useEffect, useState } from "react";
import { DatabaseBackup, Trash2 } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { fmtDateTime } from "../lib/format";

export default function BackupPanel() {
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/backups").then(({ data }) => setList(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    setBusy(true);
    try { await api.post("/admin/backups", { label: "manuale" }); toast.success("Backup creato"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Backup fallito"); }
    finally { setBusy(false); }
  };
  const remove = async (id) => { await api.delete(`/admin/backups/${id}`); toast.success("Backup eliminato"); load(); };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5" data-testid="backup-panel">
      <p className="text-sm font-heading font-semibold flex items-center gap-2 mb-2"><DatabaseBackup className="w-4 h-4 text-teal-600" /> Backup database</p>
      <p className="text-sm text-slate-500 mb-3">Snapshot completo (mongodump) salvato in <span className="font-mono text-xs">/app/backups</span>. Ripristino via CLI: <span className="font-mono text-xs">python backup.py restore ID</span>.</p>
      <Button data-testid="create-backup-btn" onClick={create} disabled={busy} className="bg-navy-900 hover:bg-navy-700 text-white gap-1.5"><DatabaseBackup className="w-4 h-4" />{busy ? "Creazione…" : "Crea backup ora"}</Button>
      <div className="mt-3 space-y-1.5">
        {list.length === 0 && <p className="text-xs text-slate-400">Nessun backup presente</p>}
        {list.map((b) => (
          <div key={b.id} data-testid={`backup-row-${b.id}`} className="flex items-center gap-3 text-xs p-2 rounded-lg bg-slate-50">
            <span className="font-mono text-slate-700">{b.id}</span>
            <span className="text-slate-400">{fmtDateTime(b.created_at)}</span>
            <span className="text-slate-500 ml-auto">{b.counts?.companies ?? 0} aziende · {b.counts?.contacts ?? 0} contatti · {Math.round((b.size_bytes || 0) / 1024)} KB</span>
            <button data-testid={`delete-backup-${b.id}`} onClick={() => remove(b.id)} className="text-red-500 hover:bg-red-50 rounded p-1"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
